import React, { useState } from "react";
import ProgressCalculationComp from "./permission.component";
import { useTranslation } from 'react-i18next';

const MetricPermissions = props => {
  const [permissionHelpPopUp, setPermissionHelpPopUp] = useState(false);
  const { t, i18n } = useTranslation();
  return (
    <div className="metric-submenu-section">
      <div className="viewPermissionArea">
        <span>
          {t('View permissions in addition to')}{" "}
          {props.goalDetails.type == 1 ? ` ${t('team')} ` : ` ${t('owner')} `}
          <div
            className="metricTargetHelptext permissionHelpText"
            onMouseEnter={event => {
              setPermissionHelpPopUp(true);
            }}
            onMouseLeave={event => {
              setPermissionHelpPopUp(false);
            }}
          />
          {permissionHelpPopUp && (
            <div className="basic-popup">
              {t(`You can give your whole organization permission to view your Key Result, or just your team and managers`)}
            </div>
          )}
        </span>
      </div>
      <div className="pT10">
        <ProgressCalculationComp
          item={props.item}
          goalDetails={props.goalDetails}
          teamPermissionData={props.setTeamPermissions}
          permissionData={props.setPermissions}
          hide={false}
        />
      </div>
    </div>
  );
};

export default MetricPermissions;
